const dayAbbreviation = ['D', 'L', 'M', 'M', 'J', 'V', 'S']
const dayList   = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
const monthList = ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jui', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec']
const monthLongList = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']

export default {
    formatDisplay (date) {
        return `${dayList[date.getDay()]}, ${monthList[date.getMonth()]} ${date.getDate()}`
    },
    formatMonth (date) {
        return `${monthLongList[date.getMonth()]} ${date.getFullYear()}`
    },
    getWeekDayArray (firstDayOfWeek) {
        let beforeArray = []
        let afterArray = []
        for (let i = 0; i < dayAbbreviation.length; i++) {
        if (i < firstDayOfWeek) {
            afterArray.push(dayAbbreviation[i])
        } else {
            beforeArray.push(dayAbbreviation[i])
        }
        }
        return beforeArray.concat(afterArray)
    },
    formatLocale(datef, format){
        format = format || 'fr'
        let dateRet = ''
        let dateTab = [ '', '', '' ]
        if( datef.indexOf('-') == 4 ){
            dateTab = datef.split('-')
        } else if ( datef.indexOf('-') == 4 ) {
            dateTab = datef.split('/')
        }
        // Formatage
        if( format == 'fr' ){
            dateRet = dateTab[2] + '/' + dateTab[1] + '/' + dateTab[0]
        } else {
            dateRet = dateTab[2] + '/' + dateTab[1] + '/' + dateTab[0]
        }
        return dateRet
    }
}


// WEBPACK FOOTER //
// ./src/plugin/dateLocale.js